import { useEffect, useState } from "react";

interface OfficeTelecomViewProps {
  data: {
    finessePeripheralSet: number | null;
  };
}

interface Details {
  FinessePeripheralSet: [string, number | null];
}

const OfficeTelecomView: React.FC<OfficeTelecomViewProps> = ({ data }) => {
  const [details, setDetails] = useState<Details | null>(null);

  useEffect(() => {
    if (data) {
      setDetails({
        FinessePeripheralSet: [
          "Finesse Peripheral Set",
          data.finessePeripheralSet,
        ],
      });
    }
  }, [data]);

  return (
    <div className="w-full">
      <div className="grid text-xs px-9 py-2 gap-y-1">
        {details &&
          Object.values(details).map((item, i) => (
            <div key={i} className="w-full border-b border-gray-200 py-1">
              <div className="grid grid-cols-4">
                <div className="expandedLabel fontExpand text-left">
                  <span>{item[0]}:</span>
                </div>
                <span className="expandedData fontExpand -ml-4">
                  {item[1] === 0 || item[1] === "NULL" ? "" : item[1]}
                </span>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default OfficeTelecomView;
